// CacheKey 8e5c180fbe4513bef62600ca6f0b8cd2
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-DICTIONARY_TEST_PROVIDER": {
    models: {
      encounter: "episode",
      encounters: "episodes",
      Encounter: "Episode",
      Encounters: "Episodes",
      patient: "member",
      patients: "members",
      Patient: "Member",
      Patients: "Members"
    },
    ribbon: {
      patient_information: "Member Information"
    },
    admitted_patients: {
      title: "Admitted Members"
    },
    monitored_patients: {
      title: "Monitored Members"
    },
    my_patient_panel: {
      title: "My Member Panel"
    },
    patients_search: {
      nav_menu: "Members"
    }
  }
}

